import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const Etuis = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/etuis/1.jpg',
    '/images/etuis/2.jpeg',
    '/images/etuis/3.jpeg',
    '/images/etuis/4.jpeg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Etuis Personalisé</h2>
            <p>
            un choix classique et polyvalent apprécié pour une gamme variée de produits tels que les cosmétiques, les bougies, les savons, et les huiles CBD. Nos étuis sont entièrement personnalisable avec le design de votre choix afin de sublimer vos produits et votre marque. Chez EMPACK nous vous proposons également plusieurs finitions d'ennoblissement telles que la dorure à chaud, le vernis 3D ou encore le gaufrage.  
            <br/><br/>
Obtenez un emballage qui correspond parfaitement à vos besoins et valorisez vos produits avec style. Si vous hésitez sur le choix de l'étuis, nous vous aidons à bien choisir votre étui ! 
            </p>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Etuis;